import React, { createContext, useContext, useState, useCallback } from "react";

const AssessmentContext = createContext(null);

const initialClient = {
  stage: "existing", // "existing" | "pre_start"
  business_name: "",
  industry: "",
  contact_person: "",
  revenue_range: "",
  employees: "",
  accounting_software: "",
  state_location: "",
};

export const AssessmentProvider = ({ children }) => {
  const [client, setClient] = useState(initialClient);
  const [answers, setAnswers] = useState({});
  const [customNotes, setCustomNotes] = useState("");

  const updateClient = useCallback((patch) => {
    setClient((prev) => {
      // If business stage changes, clear previous answers to avoid mixing question sets
      if (patch.stage && patch.stage !== prev.stage) {
        setAnswers({});
      }
      return { ...prev, ...patch };
    });
  }, []);

  const setAnswer = useCallback((qid, value) => {
    setAnswers((prev) => ({ ...prev, [qid]: value }));
  }, []);

  const reset = useCallback(() => {
    setClient(initialClient);
    setAnswers({});
    setCustomNotes("");
  }, []);

  return (
    <AssessmentContext.Provider
      value={{ client, updateClient, answers, setAnswer, customNotes, setCustomNotes, reset }}
    >
      {children}
    </AssessmentContext.Provider>
  );
};

export const useAssessment = () => {
  const ctx = useContext(AssessmentContext);
  if (!ctx) throw new Error("useAssessment must be used inside AssessmentProvider");
  return ctx;
};
